import { render } from "./MbFromStationCaution.vue?vue&type=template&id=f25b207c&scoped=true"
import script from "./MbFromStationCaution.vue?vue&type=script&lang=js"
export * from "./MbFromStationCaution.vue?vue&type=script&lang=js"

import "./MbFromStationCaution.vue?vue&type=style&index=0&id=f25b207c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f25b207c"

export default script